/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthTenantsRouteImport } from './routes/_auth.tenants'
import { Route as AuthObservabilityRouteImport } from './routes/_auth.observability'
import { Route as AuthDashboardRouteImport } from './routes/_auth.dashboard'
import { Route as AuthTenantsIndexRouteImport } from './routes/_auth.tenants.index'
import { Route as AuthTenantsTenantIdRouteImport } from './routes/_auth.tenants.$tenantId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTenantsRoute = AuthTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AuthRoute,
} as any)
const AuthObservabilityRoute = AuthObservabilityRouteImport.update({
  id: '/observability',
  path: '/observability',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTenantsIndexRoute = AuthTenantsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthTenantsRoute,
} as any)
const AuthTenantsTenantIdRoute = AuthTenantsTenantIdRouteImport.update({
  id: '/$tenantId',
  path: '/$tenantId',
  getParentRoute: () => AuthTenantsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthDashboardRoute
  '/observability': typeof AuthObservabilityRoute
  '/tenants': typeof AuthTenantsRouteWithChildren
  '/tenants/$tenantId': typeof AuthTenantsTenantIdRoute
  '/tenants/': typeof AuthTenantsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthDashboardRoute
  '/observability': typeof AuthObservabilityRoute
  '/tenants/$tenantId': typeof AuthTenantsTenantIdRoute
  '/tenants': typeof AuthTenantsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/observability': typeof AuthObservabilityRoute
  '/_auth/tenants': typeof AuthTenantsRouteWithChildren
  '/_auth/tenants/$tenantId': typeof AuthTenantsTenantIdRoute
  '/_auth/tenants/': typeof AuthTenantsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/observability'
    | '/tenants'
    | '/tenants/$tenantId'
    | '/tenants/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard'
    | '/observability'
    | '/tenants/$tenantId'
    | '/tenants'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/dashboard'
    | '/_auth/observability'
    | '/_auth/tenants'
    | '/_auth/tenants/$tenantId'
    | '/_auth/tenants/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/tenants': {
      id: '/_auth/tenants'
      path: '/tenants'
      fullPath: '/tenants'
      preLoaderRoute: typeof AuthTenantsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/observability': {
      id: '/_auth/observability'
      path: '/observability'
      fullPath: '/observability'
      preLoaderRoute: typeof AuthObservabilityRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tenants/': {
      id: '/_auth/tenants/'
      path: '/'
      fullPath: '/tenants/'
      preLoaderRoute: typeof AuthTenantsIndexRouteImport
      parentRoute: typeof AuthTenantsRoute
    }
    '/_auth/tenants/$tenantId': {
      id: '/_auth/tenants/$tenantId'
      path: '/$tenantId'
      fullPath: '/tenants/$tenantId'
      preLoaderRoute: typeof AuthTenantsTenantIdRouteImport
      parentRoute: typeof AuthTenantsRoute
    }
  }
}

interface AuthTenantsRouteChildren {
  AuthTenantsTenantIdRoute: typeof AuthTenantsTenantIdRoute
  AuthTenantsIndexRoute: typeof AuthTenantsIndexRoute
}

const AuthTenantsRouteChildren: AuthTenantsRouteChildren = {
  AuthTenantsTenantIdRoute: AuthTenantsTenantIdRoute,
  AuthTenantsIndexRoute: AuthTenantsIndexRoute,
}

const AuthTenantsRouteWithChildren = AuthTenantsRoute._addFileChildren(
  AuthTenantsRouteChildren,
)

interface AuthRouteChildren {
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthObservabilityRoute: typeof AuthObservabilityRoute
  AuthTenantsRoute: typeof AuthTenantsRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDashboardRoute: AuthDashboardRoute,
  AuthObservabilityRoute: AuthObservabilityRoute,
  AuthTenantsRoute: AuthTenantsRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
